import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { Button } from '../../ui/components/Button';
import { FormEvent, useState } from 'react';
import { api } from '../api';

export const SubscriptionForm = () => {

  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState<boolean>(false);

  const [createSubscription] = api.useCreateSubscriptionMutation({
    selectFromResult: () => ({})
  });

  const handleSubmit = async (evt: FormEvent) => {
    evt.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);

    const { error: elementsError } = await elements.submit();
    console.log(elementsError);

    const { error: tokenError, confirmationToken } = await stripe.createConfirmationToken({
      elements
    });

    console.log(tokenError, confirmationToken);

    if (!tokenError && confirmationToken) {
      const subscription = await createSubscription(confirmationToken.id).unwrap();
      console.log(subscription);

      const confirmFunc = subscription.pending_setup_intent ? stripe.confirmSetup : stripe.confirmPayment;

      const clientSecret = subscription.pending_setup_intent?.client_secret || subscription.latest_invoice?.payment_intent?.client_secret;

      if (clientSecret) {
        const retVal = await confirmFunc({
          elements,
          clientSecret,
          confirmParams: {
            return_url: window.location.href
          },
          redirect: 'if_required'
        });
        console.log(retVal);
      }
    }


    setLoading(false);
  };

  return (
    <form
      className='grow flex flex-col justify-between'
      onSubmit={handleSubmit}
    >
      <PaymentElement />
      <Button
        className='mt-4 self-end'
        disabled={!stripe || loading}
        grow={false}
        type='submit'
      >
        Subscribe now
      </Button>
    </form>
  );
};
